import React from 'react';

import { Form } from 'semantic-ui-react';

const GruppeForm = ({ formData, handleInputChange, isGruppeNameDuplicate }) => {
  return (
    <Form>
      <div className="bezug-info">
        <Form.Field error={isGruppeNameDuplicate}>
          <label>
            <strong>Name (*):</strong>
          </label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            required
          />
        </Form.Field>
        {isGruppeNameDuplicate && (
          <div className="speech-bubble warning">
            Gruppe mit diesem Namen existiert bereits
          </div>
        )}
        <p className="disclaimer">* Pflichtfeld</p>
      </div>
    </Form>
  );
};

export default GruppeForm;
